import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import SFLandingPageMetaTags from "./component";
import { withRouter } from "react-router";

const mapStateToProps = () => ({});

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);
export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(SFLandingPageMetaTags)
);
